import { CoreService } from './../../base/core';
import { Injectable } from '@angular/core';
import { ServiceRoute } from '../../base/service-route';
import { CommonHttpOption } from '../../base/common-http-option';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor( private core:CoreService) { }

  getIndicator():Observable<any>{
   return this.core.get(ServiceRoute.companySetting.indicator,new CommonHttpOption().headers)
  }
  getContractDate():Observable<any>{
    return this.core.get(ServiceRoute.companySetting.getContractDate,new CommonHttpOption().headers)
  }

  getTimeLine():Observable<any> {
    return this.core.get(ServiceRoute.companySetting.getTimeLine,new CommonHttpOption().headers)
  }
}
